<div (mouseleave)="toggleSidebar()" [class.open]="isOpen" class="sidebar">
  <div class="flex flex-col gap-1 mx-2">
    <!--    <button (click)="toggleSidebar()" class="!shadow-md self-center !bg-white text-gray-500 mb-2" mat-mini-fab>-->
    <!--      <mat-icon>close</mat-icon>-->
    <!--    </button>-->
    <ng-container *ngFor="let menu of menuItems; let i = index">
      <div *ngxPermissionsOnly="menu?.permission" class="move-up" style="--order: {{ i * 0.7 }}">
        <ng-container *ngIf="!menu.children">
          <div (click)="onMenuClick()" [routerLink]="menu?.route"
               class="text-xs p-2 bg-grey/40 rounded-md text-gray-500
                    transform cursor-pointer hover:!bg-grey/100 transition-all duration-300"
               matRipple routerLinkActive="active-menu">
            <div class="flex justify-start items-center gap-2 active-menu-item">
              <ng-container *ngIf="menu.icon">
                <mat-icon *ngIf="menu.iconType == 'SVG'" [svgIcon]="menu.icon"
                          class="!h-6 !w-6  opacity-80 transition-all duration-300 group-hover:opacity-100"></mat-icon>
                <mat-icon *ngIf="menu.iconType == 'MAT'"
                          class="opacity-80 transition-all duration-300 group-hover:!opacity-100">{{
                    menu.icon
                  }}
                </mat-icon>
              </ng-container>
              <div>{{ menu?.name }}</div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="menu?.children">
          <mat-accordion>
            <mat-expansion-panel (expandedChange)="changeOpenedMenu($event, menu.name)"
                                 [expanded]="!!menu?.key && menu?.key == currentMenu" class="!shadow-none"
                                 hideToggle>
              <mat-expansion-panel-header
                [ngClass]="{'active-menu': !isActiveRoute(menu.route)}"
                class="transition text-xs p-2  rounded-md !shadow-none mat-elevation-z0
                    transform cursor-pointer !bg-grey/40 hover:!bg-grey/100 !text-gray-500"
                matRipple>
                <mat-panel-title>
                  <div class="flex justify-start items-center gap-1">
                    <ng-container *ngIf="menu.icon">
                      <mat-icon *ngIf="menu.iconType == 'SVG'" [svgIcon]="menu.icon"
                                class="!h-6 !w-6 opacity-80 transition-all duration-300 group-hover:opacity-100"></mat-icon>
                      <mat-icon *ngIf="menu.iconType == 'MAT'"
                                class=" opacity-80 transition-all duration-300 group-hover:!opacity-100">{{ menu.icon }}
                      </mat-icon>
                    </ng-container>
                    <div>{{ menu?.name }}</div>
                  </div>
                </mat-panel-title>
                <mat-icon *ngIf="expandedMenu !== menu.name; else less">expand_more</mat-icon>
                <ng-template #less>
                  <mat-icon color="primary">expand_less</mat-icon>
                </ng-template>
              </mat-expansion-panel-header>
              <div class="flex flex-col">
                <div *ngFor="let menuItem of menu?.children; let k = index" class="flex flex-col group">
                  <ng-container *ngxPermissionsOnly="menuItem?.permission">
                    <ng-container *ngIf="!menuItem.children">
                      <div class="flex ml-4 border-l border-l-primary-800/40 items-center h-full">
                        <div class="w-6">
                          <mat-divider class="bg-primary-800/40"></mat-divider>
                        </div>
                        <div
                          [routerLink]="menuItem.route"
                          class="!pr-8 !pl-4 !py-4 w-full text-xs rounded-lg cursor-pointer flex items-center group-hover:!bg-gray-100 transition transform "
                          matRipple
                          routerLinkActive="active-menu-sub">
                          <div
                            class="h-[4px] w-[4px] transition-all duration-300 group-hover:w-[12px] rounded-full bg-gray-300 mr-3">
                          </div>
                          <span>{{ menuItem.name }}</span>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="menuItem?.children">
                      <mat-accordion>
                        <mat-expansion-panel
                          (click)="currentMenu = menuItem?.key"
                          [expanded]=" !!menuItem?.key && menuItem?.key == currentMenu">
                          <mat-expansion-panel-header
                            class="hover:!bg-menu-hover transition transform hover:scale-x-102 border-r-4 border-r-transparent hover:border-r-primary">
                            <mat-panel-title class="big-menu-items !pl-4"> <span *ngIf="menuItem.icon"
                                                                                 class="ks-icon fa fa-{{ menuItem?.icon }}"></span>
                              <span
                                *ngIf="menuItem?.icon">&nbsp;</span> {{ menuItem?.name }}
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="flex flex-col">
                            <!--                                  <mat-divider></mat-divider>-->
                            <ng-container *ngFor="let menuItemChild of menuItem?.children; let i = index">
                              <div *ngxPermissionsOnly="menuItemChild?.permission" class="flex flex-col">
                                <div>
                                  <a [routerLink]="menuItemChild.route"
                                     class="!pl-12 !py-5 font-light hover:!bg-menu-hover transition transform hover:scale-x-102"
                                     routerLinkActive="active-menu"> <span *ngIf="menuItemChild?.icon">&nbsp;</span>
                                    <span>{{
                                        menuItemChild.name
                                      }}</span> </a>
                                      
                                  <!--                                      <mat-divider-->
                                  <!--                                        *ngIf="menuItem.children?.length != i + 1"></mat-divider>-->
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <!--                <mat-divider></mat-divider>-->
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
<button (mouseover)="toggleSidebar()" *ngIf="!isOpen" class="!shadow-md mx-2 !bg-white text-gray-500 mb-1" mat-mini-fab>
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>
